import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { IUser } from 'src/app/model/service/iuser';
import { environment } from 'src/environments/environment';
import { extractApplicant, millisRemaining, validate } from './token-util';

@Injectable({
  providedIn: 'root',
})
export class AuthService {

  private readonly AUTH_TOKEN_NAME = 'auth_token';
  private readonly STORAGE = sessionStorage;
  private refreshTimer;

  constructor(private client: HttpClient) { }

  public getToken(): string { return this.STORAGE.getItem(this.AUTH_TOKEN_NAME); }
  public isValid(): boolean { return validate(this.getToken()); }
  public getUser(): IUser { 
    let applicant =extractApplicant(this.getToken());
    return applicant; 
  }

  public setToken(token: string): void {
    this.STORAGE.setItem(this.AUTH_TOKEN_NAME, token);
    const timeout = this.getTimeRemaining(token);
    this.startRefreshTimer(timeout);
  }

  public logout(): Observable<any> {
    if (!environment.production) {
      // prevent CORS error when running localy.
      return of(null);
    }
    return this.client.get<any>(environment.authUrl + '/logout', { withCredentials: true }).pipe(catchError(() => of(null)));
  }

  public clearToken(): void {
    this.STORAGE.removeItem(this.AUTH_TOKEN_NAME);
    clearTimeout(this.refreshTimer);
  }

  public isAuthorized(): Observable<boolean> {
    return this.client.get<boolean>(environment.baseUrl + '/v1/authorized');
  }

  private getTimeRemaining(token: string): number {
    return millisRemaining(token);
  }

  private startRefreshTimer(timeout: number): void {
    clearTimeout(this.refreshTimer);
    // Refresh token one minute before expiration.
    this.refreshTimer = setTimeout(() => this.updateToken(), timeout - 1000 * 60);
  }

  private updateToken(): void {
    this.client.get<{ token: string }>(environment.authUrl + '/refresh')
      .subscribe((value) => this.setToken(value.token));
  }
}
